import { EstabelecimentoService } from 'src/app/services/estabelecimento.service';
import { ModalProvider } from './../../providers/modal.provider';
import { RecursosHumanosEstabelecimentoService } from './../../services/recursos-humanos-estabelecimento.service';
import { Component, OnInit } from '@angular/core';
import { ModalController, NavParams } from '@ionic/angular';
import * as moment from 'moment';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Util } from '../../utils/util';
import { MensagemService } from '../../pages/gestor/shared/services/mensagem.service';

@Component({
  selector: 'app-modal-desativacao-reativacao',
  templateUrl: './modal-desativacao-reativacao.component.html',
  styleUrls: ['./modal-desativacao-reativacao.component.scss'],
})
export class ModalDesativacaoReativacaoComponent implements OnInit {

  disabled = false;
  cities: Array<any> = [];
  selectedItems: Array<any> = [];
  dropdownSettings: any = {};
  dataSolicitacao = moment().format('DD/MM/YYYY');

  public modalForm: FormGroup = this.formBuilder.group({
    id: [''],
    codigoMotivoSolicitacao: ['', Validators.required],
    motivoSolicitacao: ['', Validators.required],
    dataSolicitacao: ['', Validators.required],
    justificativa: ['', Validators.required],
  }, { updateOn: 'blur' });
  public validationMessages = {
    motivoSolicitacao: [
      { type: 'required', message: 'Motivo da desativação é obrigatório.' }
    ],
    dataSolicitacao: [
      { type: 'required', message: 'Data da solicitação é obrigatório.' }
    ],
    justificativa: [
      { type: 'required', message: 'Justificativa é obrigatório.' }
    ]
  };

  constructor(
    private modalController: ModalController,
    private formBuilder: FormBuilder,
    private mensagemService: MensagemService,
    private recursosHumanosEstabelecimentoService: RecursosHumanosEstabelecimentoService,
    private modalProvider: ModalProvider,
    private estabelecimentoService: EstabelecimentoService,
    private navParams: NavParams
  ) { }

  async ngOnInit() {
    this.modalForm.get('dataSolicitacao').setValue(this.dataSolicitacao);
    this.modalForm.get('id').setValue(this.navParams.get('id'));

    this.selectedItems = [{ item_id: 4, item_text: 'Pune' }, { item_id: 6, item_text: 'Navsari' }];
    this.dropdownSettings = {
      singleSelection: false,
      idField: 'item_id',
      textField: 'item_text',
      selectAllText: 'Select All',
      unSelectAllText: 'UnSelect All',
      itemsShowLimit: 3,
      defaultOpen: false,
      enableCheckAll: false,
      allowSearchFilter: true,
      limitSelection: -1
    };
    /*this.cboForm = this.formBuilder.group({
        city: [this.selectedItems]
    });*/
  }
  async enviar(opcao) {
    this.salvar();
  }

  async salvar() {
    if (this.modalForm.valid) {
      const form = this.modalForm.getRawValue();
      await this.modalController.dismiss(form);
    } else {
      Util.touchAllControls(this.modalForm);
      await this.mensagemService.showToast('Preencha os campos corretamente.');
    }
  }

  onItemSelect(item: any) {
    console.log('onItemSelect', item);
  }

  async fechar(opcao) {
    await this.modalController.dismiss(true);
  }

  async selectMotivo() {
    try {
      await this.mensagemService.presentLoading('Carregando...');
      this.modalForm.get('codigoMotivoSolicitacao').setErrors(null);
      this.modalForm.get('motivoSolicitacao').setErrors(null);

      const result: any = await this.recursosHumanosEstabelecimentoService.ListarMotivosDesativacao();
      const options: any = {
        showPesquisa: true,
        titulo: 'Selecione o Motivo da desativação',
        nomeAtributoDescricao: 'descricao',
        nomeAtributoCodigo: 'codigo'
      }
      options.lista = result.records.sort((a, b) => {
        if (a.descricao < b.descricao) {
          return -1;
        } else {
          return true;
        }
      })
      await this.mensagemService.dismissLoading();
      const data: any = await this.modalProvider.show(options);
      if (data) {
        console.log('data', data)
        this.modalForm.get('codigoMotivoSolicitacao').setValue(data.codigo);
        this.modalForm.get('motivoSolicitacao').setValue(data.descricao);
      }
    } catch (e) {
      console.error(e);
      await this.mensagemService.dismissLoading();
      await this.mensagemService.showToast('Não existe Motivos de desativação');
    }
  }
}
